module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/green.png?bd7c2877";